import servingsSelect from './servingsSelect';
const els = document.querySelectorAll('.js-servings-select');

for (let el of els) {
    servingsSelect(el);
}
